package provider

import androidx.compose.runtime.staticCompositionLocalOf

val LocalExternalsProvider = staticCompositionLocalOf<CommonExternalsProvider> { error("LocalExternalsProvider not defined") }

abstract class CommonExternalsProvider {

    abstract fun openInBrowser(url: String)

    abstract fun isGeolocationAvailable(): Boolean

    abstract suspend fun getGeoLocation(): Pair<Double, Double>?
}
